import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import SplashIntro from "./components/SplashIntro";
import Home from "./pages/Home";
import Services from "./pages/Services";
import Team from "./pages/Team";
import Insights from "./pages/Insights";
import InsightDetail from "./pages/InsightDetail";
import Contact from "./pages/Contact";
import { FirmProvider } from "./context/FirmContext";

function App() {
  return (
    <div className="App">
      <FirmProvider>
        <BrowserRouter>
          <SplashIntro />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/team" element={<Team />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </FirmProvider>
    </div>
  );
}

export default App;
